module.exports = __webpack_public_path__ + "img/icon_e62.7d4d514b.png";